/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
// This sample uses the Places Autocomplete widget to:
// 1. Help the user select a place
// 2. Retrieve the address components associated with that place
// 3. Populate the form fields with those address components.
// This sample requires the Places library, Maps JavaScript API.
// Include the libraries=places parameter when you first load the API.
// For example: <script
// src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
let autocomplete;
let txtAddress;
let address2Field;
let postalField;

function initAutocomplete() {
  txtAddress = document.querySelector("#lil-pers-text-coord");
  // Create the autocomplete object, restricting the search predictions to
  // addresses in the US and Canada.
  autocomplete = new google.maps.places.Autocomplete(txtAddress, {
    fields: ["address_components", "geometry"],
  });
  txtAddress.focus();
  // When the user selects an address from the drop-down, populate the
  // address fields in the form.
  autocomplete.addListener("place_changed", fillInAddress);
}

function fillInAddress() {
  // Get the place details from the autocomplete object.
  const place = autocomplete.getPlace();
  
  var text_address = "";
  var text_num = "";
  var text_city = "";
  var text_postcode = "";
  var text_region = "";
  var text_country = "";

  console.log(place.address_components);

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // place.address_components are google.maps.GeocoderAddressComponent objects
  // which are documented at http://goo.gle/3l5i5Mr
  for (const component of place.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
      case "street_number": text_num = component.long_name; break; 
      case "route": text_address += component.short_name; break; 
      case "postal_code": text_postcode = component.long_name; break; 
      case "locality": text_city = component.long_name; break;
      case "administrative_area_level_1": text_region = component.short_name; break;
      case "country": text_country = component.long_name; break;
    }
  }

  var full_address = text_address + " " + text_num + ", " + text_postcode + " " + text_city + " " + text_region + " " + text_country;
  console.log(full_address);

  insertGeoData(place.geometry.location.lat(), place.geometry.location.lng(), full_address);
}

function insertGeoData(lat, lon, full_address){
  var input = $("#lil-pers-text");

  var latitude = convertCoordinate(lat);
  var longitude = convertCoordinate(lon);
  var coordinates = "";

  if(lat > 0 ){
    coordinates += latitude + " N ";
  } else {
    coordinates += latitude + " S ";
  }

  if(lon > 0 ){
    coordinates += longitude + " E";
  } else {
    coordinates += longitude + " W";
  }

  console.log(lat, lon);

  input.val(coordinates);
  updateText(input);

  $(".default-box .check").html("<a href=\"https://www.google.it/maps/place/"+coordinates+"\" target='_blank'>Check: "+full_address+"</a>");
  switchPlainText();
}

function convertCoordinate(coord){
  if(coord < 0){ 
    coord = coord * -1; 
    console.log(coord);
  }
  
  var deg = Math.floor(coord);

  var first_part = (coord - deg) * 60;
  var min = Math.floor(first_part);
  console.log(min.toString().length);
  if(min.toString().length == 1){ min = "0"+min; }

  var second_part = (first_part - min) * 60;
  var sec = Math.floor(second_part);

  if(sec.toString().length == 1){ sec = "0"+sec; }

  var convertedCoordinate = deg + "°" + min + "'" + sec + "''";
  //console.log(convertedCoordinate);
  
  return convertedCoordinate;
}


window.initAutocomplete = initAutocomplete;